import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Set the SweepRuleRequestStatus in the sweep rules options store
 * @param requestStatus the get sweep rules request status to set
 */
export default action('setSweepRuleRequestStatus')(function setSweepRuleRequestStatus(requestStatus) {
    store.getSweepRulesRequestStatus = requestStatus;
});
//# sourceMappingURL=setSweepRuleRequestStatus.js.map